const YoutubeIcon = (props: { className?: string }) => {
  const { className } = props;

  return (
    <svg className={className} fill="currentColor" width="100%" height="100%" viewBox="0 0 16 16">
      <path d="M11.429 8q0-0.33-0.268-0.482l-4.571-2.857q-0.277-0.179-0.58-0.018-0.295 0.161-0.295 0.5v5.714q0 0.339 0.295 0.5 0.143 0.071 0.277 0.071 0.179 0 0.304-0.089l4.571-2.857q0.268-0.152 0.268-0.482zM16 8q0 0.857-0.009 1.339t-0.076 1.219-0.201 1.317q-0.143 0.652-0.616 1.098t-1.107 0.518q-1.982 0.223-5.991 0.223t-5.991-0.223q-0.634-0.071-1.112-0.518t-0.621-1.098q-0.125-0.58-0.192-1.317t-0.076-1.219-0.009-1.339 0.009-1.339 0.076-1.219 0.201-1.317q0.143-0.652 0.616-1.098t1.107-0.518q1.982-0.223 5.991-0.223t5.991 0.223q0.634 0.071 1.112 0.518t0.621 1.098q0.125 0.58 0.192 1.317t0.076 1.219 0.009 1.339z" />
    </svg>
  );
};

export default YoutubeIcon;
